import Star from './star';
import Point from './point';

const icons = {
  star: Star,
  point: Point,
};

export const iconsList = Object.keys(icons);
export default icons;
